import { Component, ChangeDetectorRef, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { SelectedKpi } from 'src/app/core/models/insight-configuration.model';
import { RemoveSelectedImpactedKPI, UpdateStepValidity } from 'src/app/core/store/predictive-failure-configuration/predictive-failure-configuration.action';
import { takeUntil } from 'rxjs/operators';
import { ImpactedKpiSelectionPopupComponent } from './impacted-kpi-selection-popup/impacted-kpi-selection-popup.component';
import { PREDICTIVE_CREATE_COMPONENTS } from 'src/app/core/enums/predictiveFailure.enum';
@Component({
  selector: 'app-predictive-impacted-kpi',
  templateUrl: './predictive-impacted-kpi.component.html',
  styleUrls: ['./predictive-impacted-kpi.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PredictiveImpactedKpiComponent {

  public selectKpiModalRef: BsModalRef
  public unsubscribe  = new Subject<void>();
  public dataSource = new MatTableDataSource();
  public selectedKpis : SelectedKpi[];
  public count = 0;
  public disable : boolean;
  public displayedColumns: string[] = ['name', 'role', 'department', 'ahLevel', 'frequency', 'buttons'];

  constructor(
    public router: Router,
    public modalService: BsModalService,
    private store: Store,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  @ViewChild('scheduledOrdersPaginator', {static: true}) paginator :MatPaginator;

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.store.dispatch(new UpdateStepValidity(PREDICTIVE_CREATE_COMPONENTS.IMPACTED_KPIS, true));
    this.getSelectedKPIs();
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public navigateToLanding(): void {
    this.router.navigateByUrl('/home')
  }

  public getSelectedKPIs() {
    this.store.select(state => state.configurations.predictiveFailure.impactedKpiSelected).pipe(takeUntil(this.unsubscribe))
    .subscribe(selectedKPIs => {
      this.selectedKpis = selectedKPIs;
      this.dataSource.data = selectedKPIs;
      this.count = this.selectedKpis.length
      this.changeDetectorRef.detectChanges();
    })
  }

  public onSelectKpiClicked() {
    this.selectKpiModalRef = this.modalService.show(ImpactedKpiSelectionPopupComponent, {
      class: 'modal-lg kpi-selection',
      ignoreBackdropClick: true
    })
  }

  public deleteSelectedKpi(kpi: any) {
    this.store.dispatch(new RemoveSelectedImpactedKPI(kpi));
  }

}
